import React from 'react';
import { TrendingUp, TrendingDown, TrendingFlat } from '@mui/icons-material';
import { DASHBOARD_COLORS } from '../constants/dashboardConstants';

export const getTrendColor = (trend, theme) => {
  switch (trend) {
    case 'up': return theme.palette.success.main;
    case 'down': return theme.palette.error.main;
    default: return theme.palette.warning.main;
  }
};

export const getTrendChipColor = (trend) => {
  return DASHBOARD_COLORS.TREND_COLORS[trend] || 'warning';
};

export const getTrendIcon = (trend) => {
  switch (trend) {
    case 'up': return <TrendingUp />;
    case 'down': return <TrendingDown />;
    default: return <TrendingFlat />;
  }
};

export const getTrendProps = (trend) => ({
  color: getTrendChipColor(trend),
  icon: getTrendIcon(trend)
}); 